import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Backdrop,
  CircularProgress,
  AppBar,
  Toolbar,
} from "@mui/material";
import { db } from "../../firebase/firebaseConfig";
import { collection, addDoc, getDocs, query, where, limit, serverTimestamp } from "firebase/firestore";
const Header = () => (
  <AppBar
    position="fixed"
    style={{
      backgroundColor: "#fff",
      color: "#000",
      boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
      zIndex: 1201,
    }}
  >
    <Toolbar>
      <Box display="flex" alignItems="center">
        <img
          src="https://nataonline.com/wp-content/uploads/2024/02/6.jpg"
          alt="Logo"
          style={{ height: 100 }}
        />
      </Box>
      <Box display="flex" alignItems="center" ml="auto">
        <Typography variant="h6" noWrap>
          Registro de Nuevos Aspirantes
        </Typography>
      </Box>
    </Toolbar>
  </AppBar>
);

const RegistrationPage = () => {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [humanCheck, setHumanCheck] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRecaptchaChange = (value) => {
    if (value) {
      setHumanCheck(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar formato de email antes de las validaciones de existencia en la base de datos
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.user_email)) {
      alert("❌ El correo electrónico ingresado no tiene un formato válido.");
      return;
    }

    // Validar la URL del CV
    const isValidUrl = (url) => {
      try {
        new URL(url);
        return true;
      } catch (_) {
        return false;
      }
    };

    // El campo del formulario se llama "cvLink" en el input, pero en el backend podría ser "CV_URL"
    // Usar el nombre correcto según el formData
    const cvUrlValue = formData.CV_URL !== undefined ? formData.CV_URL : formData.cvLink;
    if (!isValidUrl(cvUrlValue)) {
      alert("❌ El enlace al CV no es una URL válida. Verifica que comience con http:// o https://");
      return;
    }

    // Verificar si el usuario ya existe antes de confirmar los datos
    try {
      const email = (formData.user_email || '').trim().toLowerCase();
      const numeroDoc = (formData.numero_documento || '').trim();

      // Consulta dirigida: evita leer toda la colección y funciona aunque la colección aún no exista (retorna vacío).
      const emailQ = query(
        collection(db, "aspirantes"),
        where("user_email", "==", email),
        limit(1)
      );
      const docQ = query(
        collection(db, "aspirantes"),
        where("numero_documento", "==", numeroDoc),
        limit(1)
      );

      const [emailSnap, docSnap] = await Promise.all([getDocs(emailQ), getDocs(docQ)]);
      const alreadyExists = !emailSnap.empty || !docSnap.empty;

      if (alreadyExists) {
        alert("Ya se ha enviado una solicitud con este correo electrónico o documento. Por favor contáctese con nosotros para verificar el estado de su solicitud.");
        return;
      }
    } catch (error) {
      // No bloquear el envío por fallos en la verificación de duplicados.
      console.warn("Verificación de duplicados falló, se continúa con el envío:", error);
      // Opcionalmente podrías notificar en UI, pero no cortamos el flujo.
    }

    const confirmDatos = window.confirm("¿Está seguro de que todos sus datos están correctos?");
    if (!confirmDatos) return;

    const confirmCV = window.confirm("¿Confirmas que la URL del CV es correcta y que el documento está compartido como 'público'? Si no lo está, tu solicitud podría ser rechazada.");
    if (!confirmCV) return;
    //console.log("Iniciando envío");

    if (!humanCheck) {
      alert("Por favor confirme que es un ser humano.");
      return;
    }

    //console.log("Formulario validado, preparando datos...");
    setLoading(true);

    try {
      const normalizedEmail = (formData.user_email || '').trim().toLowerCase();
      const normalizedDoc = (formData.numero_documento || '').trim();
      const cvUrlValueFinal = formData.CV_URL !== undefined ? formData.CV_URL : formData.cvLink;

      const docRef = await addDoc(collection(db, "aspirantes"), {
        ...formData,
        user_email: normalizedEmail,
        numero_documento: normalizedDoc,
        CV_URL: cvUrlValueFinal,
        fecha_solicitud: serverTimestamp(),
        email_enviado: false, // Cloud Function lo pondrá en true al enviar email
      });

      // Save email pending in the "envio_emails" collection (no bloquear si falla)
      try {
        await addDoc(collection(db, "envio_emails"), {
          nombre: formData.nombre,
          apellido: formData.apellido,
          email: normalizedEmail,
          enviado: false,
          fecha_creacion: new Date(),
          fecha_envio: null,
          tipo: "welcome"
        });
      } catch (e) {
        console.warn("No se pudo agendar el envío de email, se continúa:", e);
      }

      // Enviar email alertando sobre nuevo registro en la plataforma
      try {
        await addDoc(collection(db, "envio_emails"), {
          nombre: formData.nombre,
          apellido: formData.apellido,
          email: "sabin.urcelay@gmail.com",
          enviado: false,
          fecha_creacion: new Date(),
          fecha_envio: null,
          tipo: "alert_new_applicant"
        });
      } catch (e) {
        console.warn("No se pudo agendar el envío de email (alerta), se continúa:", e);
      }

      //console.log("Registro enviado correctamente.");
      setSubmitted(true);
    } catch (error) {
      console.error("Error al registrar aspirante:", error);
      //console.log("Error capturado:", error.message);
      const code = error?.code || "unknown";
      alert(`Hubo un error al enviar el registro. (${code})`);
    } finally {
      setLoading(false);
    }
  };

  // Eliminado el return anticipado por submitted.

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Header />
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#f5f5f5",
          padding: "24px",
          mb: 4,
          mt: 12,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body1">
            Por favor, complete este formulario con la mayor cantidad de información posible. Esto nos permitirá conocerle mejor y facilitar su incorporación a la comunidad GCIAMT.
          </Typography>
        </Container>
      </Box>
      <Container maxWidth="lg" sx={{ mt: 6 }}>
        <form onSubmit={handleSubmit}>
        {/* Datos Personales */}
        <Box mb={4} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" gutterBottom>
            Datos Personales
          </Typography>
          <table style={{ width: "100%", tableLayout: "fixed", borderSpacing: "16px 12px" }}>
            <tbody>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Nombre" name="nombre" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Apellido" name="apellido" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    select
                    label="Género"
                    name="genero"
                    fullWidth
                    sx={{ width: "100%" }}
                    required
                    onChange={handleChange}
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>
                      Seleccione...
                    </MenuItem>
                    <MenuItem value="Masculino">Masculino</MenuItem>
                    <MenuItem value="Femenino">Femenino</MenuItem>
                  </TextField>
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Dirección Personal" name="direccion" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    label="Fecha de Nacimiento"
                    name="birth_date"
                    type="date"
                    fullWidth
                    sx={{ width: "100%" }}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    select
                    label="País de Nacimiento"
                    name="country"
                    fullWidth
                    sx={{ width: "100%" }}
                    required
                    onChange={handleChange}
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>
                      Seleccione...
                    </MenuItem>
                    <MenuItem value="Argentina">🇦🇷 Argentina</MenuItem>
                    <MenuItem value="Brasil">🇧🇷 Brasil</MenuItem>
                    <MenuItem value="Chile">🇨🇱 Chile</MenuItem>
                    <MenuItem value="Uruguay">🇺🇾 Uruguay</MenuItem>
                    <MenuItem value="Paraguay">🇵🇾 Paraguay</MenuItem>
                    <MenuItem value="Bolivia">🇧🇴 Bolivia</MenuItem>
                    <MenuItem value="Perú">🇵🇪 Perú</MenuItem>
                    <MenuItem value="Ecuador">🇪🇨 Ecuador</MenuItem>
                    <MenuItem value="Colombia">🇨🇴 Colombia</MenuItem>
                    <MenuItem value="Venezuela">🇻🇪 Venezuela</MenuItem>
                    <MenuItem value="México">🇲🇽 México</MenuItem>
                    <MenuItem value="Guatemala">🇬🇹 Guatemala</MenuItem>
                    <MenuItem value="Honduras">🇭🇳 Honduras</MenuItem>
                    <MenuItem value="El Salvador">🇸🇻 El Salvador</MenuItem>
                    <MenuItem value="Nicaragua">🇳🇮 Nicaragua</MenuItem>
                    <MenuItem value="Costa Rica">🇨🇷 Costa Rica</MenuItem>
                    <MenuItem value="Panamá">🇵🇦 Panamá</MenuItem>
                    <MenuItem value="Cuba">🇨🇺 Cuba</MenuItem>
                    <MenuItem value="República Dominicana">🇩🇴 República Dominicana</MenuItem>
                    <MenuItem value="España">🇪🇸 España</MenuItem>
                    <MenuItem value="Portugal">🇵🇹 Portugal</MenuItem>
                    <MenuItem value="Francia">🇫🇷 Francia</MenuItem>
                    <MenuItem value="Italia">🇮🇹 Italia</MenuItem>
                    <MenuItem value="Alemania">🇩🇪 Alemania</MenuItem>
                    <MenuItem value="Reino Unido">🇬🇧 Reino Unido</MenuItem>
                    <MenuItem value="Irlanda">🇮🇪 Irlanda</MenuItem>
                    <MenuItem value="Bélgica">🇧🇪 Bélgica</MenuItem>
                    <MenuItem value="Países Bajos">🇳🇱 Países Bajos</MenuItem>
                    <MenuItem value="Suiza">🇨🇭 Suiza</MenuItem>
                    <MenuItem value="Austria">🇦🇹 Austria</MenuItem>
                    <MenuItem value="Noruega">🇳🇴 Noruega</MenuItem>
                    <MenuItem value="Suecia">🇸🇪 Suecia</MenuItem>
                    <MenuItem value="Finlandia">🇫🇮 Finlandia</MenuItem>
                    <MenuItem value="Dinamarca">🇩🇰 Dinamarca</MenuItem>
                    <MenuItem value="Polonia">🇵🇱 Polonia</MenuItem>
                    <MenuItem value="Hungría">🇭🇺 Hungría</MenuItem>
                    <MenuItem value="República Checa">🇨🇿 República Checa</MenuItem>
                  </TextField>
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    label="Teléfono Móvil (ej: +54 91123456789)"
                    name="telefono_movil"
                    fullWidth
                    required
                    sx={{ width: "100%" }}
                    onChange={handleChange}
                    placeholder="+54 91123456789"
                  />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Correo Electrónico Personal (solo 1 " name="user_email" type="email" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
              </tr>
              {/* Nueva fila para Número de Pasaporte / Documento de Identidad */}
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    label="Número de Pasaporte / Documento de Identidad"
                    name="numero_documento"
                    fullWidth
                    sx={{ width: "100%" }}
                    required
                    onChange={handleChange}
                  />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}></td>
              </tr>
            </tbody>
          </table>
        </Box>

        {/* Datos Profesionales */}
        <Box mb={4} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" gutterBottom>
            Datos Profesionales
          </Typography>
          <table style={{ width: "100%", tableLayout: "fixed", borderSpacing: "16px 12px" }}>
            <tbody>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <Box>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      Enlace a resumen de CV (Documento PDF alojado en Google Drive, Dropbox, etc)
                    </Typography>
                    <TextField
                      label="Enlace al Curriculum Vitae"
                      name="cvLink"
                      fullWidth
                      required
                      onChange={handleChange}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    select
                    label="Título Profesional"
                    name="titulo_profesional"
                    fullWidth
                    sx={{ width: "100%", mt: 3 }}
                    required
                    onChange={handleChange}
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>
                      Seleccione...
                    </MenuItem>
                    <MenuItem value="Doctor(a)">Doctor(a)</MenuItem>
                    <MenuItem value="Bioquímico(a)">Bioquímico(a)</MenuItem>
                    <MenuItem value="Químico(a) Farmacéutico(a)">Químico(a) Farmacéutico(a)</MenuItem>
                    <MenuItem value="Técnico(a)">Técnico(a)</MenuItem>
                    <MenuItem value="Licenciado(a)">Licenciado(a)</MenuItem>
                    <MenuItem value="Bacteriólogo(a)">Bacteriólogo(a)</MenuItem>
                    <MenuItem value="Tecnólogo(a)">Tecnólogo(a)</MenuItem>
                    <MenuItem value="Otros">Otros</MenuItem>
                  </TextField>
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Especialidad Profesional" name="especialidad" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Institución Universitaria" name="institucion" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Institución Laboral Actual" name="institucion_laboral_actual" fullWidth sx={{ width: "100%" }} required onChange={handleChange} />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    label="Teléfono (ej: +54 91123456789)"
                    name="telefono_trabajo"
                    fullWidth
                    required
                    sx={{ width: "100%" }}
                    onChange={handleChange}
                    placeholder="+54 91123456789"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </Box>

        {/* Datos de Membresía */}
        <Box mb={4} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" gutterBottom>
            Datos de Membresía
          </Typography>
          <table style={{ width: "100%", tableLayout: "fixed", borderSpacing: "16px 12px" }}>
            <tbody>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    select
                    label="País de Membresía"
                    name="country_12"
                    fullWidth
                    sx={{ width: "100%" }}
                    required
                    onChange={handleChange}
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>
                      Seleccione...
                    </MenuItem>
                    <MenuItem value="Argentina">🇦🇷 Argentina</MenuItem>
                    <MenuItem value="Brasil">🇧🇷 Brasil</MenuItem>
                    <MenuItem value="Chile">🇨🇱 Chile</MenuItem>
                    <MenuItem value="Uruguay">🇺🇾 Uruguay</MenuItem>
                    <MenuItem value="Paraguay">🇵🇾 Paraguay</MenuItem>
                    <MenuItem value="Bolivia">🇧🇴 Bolivia</MenuItem>
                    <MenuItem value="Perú">🇵🇪 Perú</MenuItem>
                    <MenuItem value="Ecuador">🇪🇨 Ecuador</MenuItem>
                    <MenuItem value="Colombia">🇨🇴 Colombia</MenuItem>
                    <MenuItem value="Venezuela">🇻🇪 Venezuela</MenuItem>
                    <MenuItem value="México">🇲🇽 México</MenuItem>
                    <MenuItem value="Guatemala">🇬🇹 Guatemala</MenuItem>
                    <MenuItem value="Honduras">🇭🇳 Honduras</MenuItem>
                    <MenuItem value="El Salvador">🇸🇻 El Salvador</MenuItem>
                    <MenuItem value="Nicaragua">🇳🇮 Nicaragua</MenuItem>
                    <MenuItem value="Costa Rica">🇨🇷 Costa Rica</MenuItem>
                    <MenuItem value="Panamá">🇵🇦 Panamá</MenuItem>
                    <MenuItem value="Cuba">🇨🇺 Cuba</MenuItem>
                    <MenuItem value="República Dominicana">🇩🇴 República Dominicana</MenuItem>
                    <MenuItem value="España">🇪🇸 España</MenuItem>
                    <MenuItem value="Portugal">🇵🇹 Portugal</MenuItem>
                    <MenuItem value="Francia">🇫🇷 Francia</MenuItem>
                    <MenuItem value="Italia">🇮🇹 Italia</MenuItem>
                    <MenuItem value="Alemania">🇩🇪 Alemania</MenuItem>
                    <MenuItem value="Reino Unido">🇬🇧 Reino Unido</MenuItem>
                    <MenuItem value="Irlanda">🇮🇪 Irlanda</MenuItem>
                    <MenuItem value="Bélgica">🇧🇪 Bélgica</MenuItem>
                    <MenuItem value="Países Bajos">🇳🇱 Países Bajos</MenuItem>
                    <MenuItem value="Suiza">🇨🇭 Suiza</MenuItem>
                    <MenuItem value="Austria">🇦🇹 Austria</MenuItem>
                    <MenuItem value="Noruega">🇳🇴 Noruega</MenuItem>
                    <MenuItem value="Suecia">🇸🇪 Suecia</MenuItem>
                    <MenuItem value="Finlandia">🇫🇮 Finlandia</MenuItem>
                    <MenuItem value="Dinamarca">🇩🇰 Dinamarca</MenuItem>
                    <MenuItem value="Polonia">🇵🇱 Polonia</MenuItem>
                    <MenuItem value="Hungría">🇭🇺 Hungría</MenuItem>
                    <MenuItem value="República Checa">🇨🇿 República Checa</MenuItem>
                  </TextField>
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    label="¿Pertenece a otras asociaciones?"
                    name="otras_asociaciones"
                    select
                    fullWidth
                    sx={{ width: "100%" }}
                    defaultValue=""
                    onChange={handleChange}
                  >
                    <MenuItem value="Sí">Sí</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Nombre de las otras asociaciones" name="otras_asociaciones_insc" fullWidth sx={{ width: "100%" }} onChange={handleChange} />
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Otros cargos o experiencia en MT" name="otros_cargos_exp" fullWidth sx={{ width: "100%" }} onChange={handleChange} />
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField
                    label="¿Conoce a algún socio del GCIAMT?"
                    name="otro_socio_gciamt"
                    select
                    fullWidth
                    sx={{ width: "100%" }}
                    defaultValue=""
                    onChange={handleChange}
                  >
                    <MenuItem value="Sí">Sí</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </td>
                <td style={{ width: "50%", overflowWrap: "break-word" }}>
                  <TextField label="Contacto Socios GCIAMT" name="contacto_socios_gciamt" fullWidth sx={{ width: "100%" }} onChange={handleChange} />
                </td>
              </tr>
            </tbody>
          </table>
        </Box>

        <Box mb={4} display="flex" alignItems="center" gap={2}>
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={handleRecaptchaChange}
          />
          {!humanCheck && (
            <Typography variant="body2" color="textSecondary">
              Por favor complete el captcha para continuar.
            </Typography>
          )}
        </Box>
          <Box mb={6}>
            <Button variant="contained" color="primary" type="submit" size="large" sx={{ py: 1.5, px: 4 }}>
              Enviar Registro
            </Button>
          </Box>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
            <CircularProgress color="inherit" />
            <Typography variant="h6" sx={{ ml: 2 }}>Espere un momento...</Typography>
          </Backdrop>
        </form>
      </Container>
      <Dialog open={submitted} onClose={() => {}} disableEscapeKeyDown>
        <DialogTitle>¡Gracias por tu registro!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" paragraph>
            Hemos recibido tu información. Pronto nos pondremos en contacto.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.href = "https://gciamt.org/"}
          >
            Ir al sitio GCIAMT
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RegistrationPage;